import { AxiosResponse } from "axios";

export function getFileName(response: AxiosResponse): string {
  const headerLine = response.headers["content-disposition"];
  const match = headerLine.match(/filename=([^;]+);/);
  if (!match) {
    throw Error("unable to get filename");
  }
  return match[1];
}
